const faqs = [
  {
    q: '屁屁影院的电视剧真的完全免费吗？',
    a: '是的。屁屁影院所有影视资源包括电视剧全集、电影大片、动漫番剧、综艺节目等均可免费在线观看，无需注册登录，无需付费会员，真正做到零门槛追剧。我们通过广告收入维持平台运营，为用户提供持续稳定的免费服务。',
  },
  {
    q: '播放会不会卡顿？画质怎么样？',
    a: '屁屁影院采用多线路智能分发技术，根据您的网络环境自动选择最优播放线路。平台支持1080P高清画质，大多数剧集提供流畅秒播体验。我们持续优化服务器性能，确保全国各地区用户都能享受流畅的观影体验。如果遇到卡顿，可以尝试切换备用线路。',
  },
  {
    q: '剧集更新速度怎么样？能同步卫视吗？',
    a: '屁屁影院拥有专业的资源更新团队，热播剧集一般在卫视播出后数小时内即可上线。我们与多家内容合作伙伴保持紧密协作，确保新剧集第一时间更新上线。每日固定时段批量更新，用户可以通过「追剧快讯」栏目查看最新上架信息。',
  },
  {
    q: '支持哪些设备观看？可以投屏吗？',
    a: '屁屁影院完美适配电脑、平板和手机等主流设备，通过浏览器即可直接访问观看，无需下载安装任何软件。平台支持 AirPlay 和 DLNA 投屏协议，您可以将内容投射到智能电视或投影仪上，享受大屏追剧体验。移动端访问自动适配触屏操作，使用便捷。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            快速了解屁屁影院，解答你的追剧疑问
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}